import { render, staticRenderFns } from "./PlatformPolicy.vue?vue&type=template&id=3812ce60&scoped=true&"
import script from "./PlatformPolicy.vue?vue&type=script&lang=js&"
export * from "./PlatformPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PlatformPolicy.vue?vue&type=style&index=0&id=3812ce60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3812ce60",
  null
  
)

export default component.exports